import { HotEventDTO, OddsAPI, RootState } from '@supersports/services';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

type HotEventSliceState = {
  hotEvents: HotEventDTO[];
  popularSearch: number[];
  loaded: boolean;
};

const initialState: HotEventSliceState = {
  hotEvents: [],
  popularSearch: [],
  loaded: false,
};

export const getHotEvents = createAsyncThunk('hotEvent/getHotEvents', async () => {
  return await OddsAPI.getHotEvents();
});

export const getPopularSearch = createAsyncThunk('hotEvent/getPopularSearch', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as RootState;
  const hotEvents = state.hotEvent.hotEvents;

  if (!hotEvents || hotEvents.length === 0) {
    return thunkAPI.dispatch(getHotEvents()).then(() => {
      const _state = thunkAPI.getState() as RootState;
      const newHotEvents = _state.hotEvent.hotEvents;
      const leagues = Array.from(new Set(newHotEvents.map((hotEvent) => hotEvent.LeagueID))).map(
        (league) => league as number
      );
      return leagues;
    });
  }

  const leagues = Array.from(new Set(hotEvents.map((hotEvent) => hotEvent.LeagueID))).map((league) => league as number);

  return leagues;
});

const hotEventSlice = createSlice({
  name: 'hotEvent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHotEvents.fulfilled, (state, action) => {
        state.hotEvents = action.payload;
        state.loaded = true;
      })
      .addCase(getPopularSearch.fulfilled, (state, action) => {
        state.popularSearch = action.payload;
      });
  },
});

export default hotEventSlice.reducer;
